import { defineStore } from 'pinia'
import { v4 as uuidv4 } from 'uuid'

import { random as randomColor } from '@/helpers/colors.js'

import { useParticipateStore } from '@/stores/ParticipateStore.js'
import { useSettingsStore } from '@/stores/SettingsStore.js'

const storeID = 'PairingStore'

const newPairing = () => {
    return {
        participates: [],
        renderColor: randomColor(),
        uuid: uuidv4()
    }
}

export const usePairingStore = defineStore(storeID, {
    state: () => ({
        pairings: []
    }),
    persist: true,
    getters: {},
    actions: {
        get(id) {
            return this.pairings.find(pairing => pairing.uuid === id)
        },
        remove(id) {
            let participateStore = useParticipateStore()

            this.pairings = this.pairings.filter((pairing) => {
                if (pairing.uuid === id) {
                    pairing.participates.forEach((participate) => {
                        participateStore.setAssignedPairing(participate, false)
                    })
                    return false
                }

                return true
            })
        },
        assign(pairingID, participateIDs) {
            let participateStore = useParticipateStore()
            let pairing = this.pairings.find(pairing => pairing.uuid == pairingID)

            if (! pairing) {
                pairing = newPairing()
                this.pairings.push(pairing)
            }

            participateIDs.forEach((id) => {
                if(! pairing.participates.find(participateID => participateID == id)) {
                    pairing.participates.push(id.value)
                    participateStore.setAssignedPairing(id.value, true)
                }
            })
        },
        unassign(pairingID, participateID) {
            let participateStore = useParticipateStore()
            let pairing = this.pairings.find(pairing => pairing.uuid == pairingID)

            pairing.participates.forEach((evaluatedParticipateID, i) => {
                if (evaluatedParticipateID === participateID) {
                    pairing.participates.splice(i, 1)
                    return true
                }
            })

            return false
        },
        getPairingTitle(id) {
            let participateStore = useParticipateStore()
            let pairing = this.pairings.find(pairing => pairing.uuid == id)

            if (pairing.participates.length == 0) {
                return 'Empty (0)'
            }

            let participateNames = pairing.participates.map(participate => {
                return participateStore.get(participate).name
            })

            return `${participateNames.join(', ')} (${pairing.participates.length})`
        },
        getPairingStatus(id) {
            let participateStore = useParticipateStore()
            let settingsStore = useSettingsStore()
            let pairing = this.pairings.find(pairing => pairing.uuid == id)

            let errors = []

            if (pairing.participates.length > settingsStore.tableSize) {
                errors.push('Pairing is larger than allowed table size')
            }

            return {
                status: (errors.length > 0) ? 'Error' : 'Approved',
                errors: errors.join(", ")
            }
        },
        reset() {
            this.pairings = []
        }
    }
})
